











import Vue from 'vue'
import {
  MESSAGE_VOTE_RESULT_YES,
  MESSAGE_VOTE_RESULT_NO,
  MESSAGE_VOTE_RESULT_1,
  MESSAGE_VOTE_RESULT_2,
  MESSAGE_VOTE_RESULT_3,
  MESSAGE_VOTE_RESULT_4,
  MESSAGE_VOTE_RESULT_5,
  MESSAGE_VOTE_RESULT_LIKE
} from '@/constants'

interface IVoteType {
  img: string,
  text?: string
}

const MESSENGER_VOTE_RESULT_TYPES: {[key: string]: IVoteType} = {
  [MESSAGE_VOTE_RESULT_YES]: {
    img: 'fingerup'
  },
  [MESSAGE_VOTE_RESULT_NO]: {
    img: 'fingerdown'
  },
  [MESSAGE_VOTE_RESULT_1]: {
    img: 'star',
    text: '1'
  },
  [MESSAGE_VOTE_RESULT_2]: {
    img: 'star',
    text: '2'
  },
  [MESSAGE_VOTE_RESULT_3]: {
    img: 'star',
    text: '3'
  },
  [MESSAGE_VOTE_RESULT_4]: {
    img: 'star',
    text: '4'
  },
  [MESSAGE_VOTE_RESULT_5]: {
    img: 'star',
    text: '5'
  },
  [MESSAGE_VOTE_RESULT_LIKE]: {
    img: 'fingerup'
  }
}
export default Vue.extend({
  props: {
    val: String
  },
  computed: {
    icon (): IVoteType | undefined {
      return MESSENGER_VOTE_RESULT_TYPES[this.val]
    }
  }
})
